<template>
  <div id="scrEnd" class="align">
    <IconBase viewBox="0 0 68 68">
      <icon></icon>
    </IconBase>
    <p class="ln1">Спасибо!</p>
    <p class="ln2">Мы приняли Вашу заявку.</p>
    <p class="ln3">Наша системы начал проверку данных. В течение 15 минут с Вами свяжется наш
      специалист для дальнейших действий. </p>
  </div>
</template>

<script>
  export default {
    name: "scrEnd",
    components: {
      IconBase: () => import('@/components/svg/IconBase'),
      icon: () => import('@/components/svg/icon'),
    },
    // mounted(){
    //   this.$store.dispatch('hideLoading');
    //   if (window.ym) {
    //     // eslint-disable-next-line no-undef
    //     ym(51632228, 'reachGoal', 'admdForm');
    //     // eslint-disable-next-line no-undef
    //     ym(51632228, 'reachGoal', 'admdChainRequest');
    //     // eslint-disable-next-line no-undef
    //     ym(51632228, 'reachGoal', 'allRequest');
    //   }
    //   if (window.ga){
    //     // eslint-disable-next-line no-undef
    //     ga('send', 'event', 'admdForm', 'admdForm');
    //   }
    //   try {
    //     // eslint-disable-next-line no-undef
    //     VK.Goal('lead')
    //   } catch (e) {
    //     console.log(e);
    //   }
    //   window.scrollTo({
    //     left:0,
    //     top:this.$parent.$refs.formAlign.offsetTop,
    //     behavior: 'smooth'
    //   });
    // }
  }
</script>

<style scoped>
  #scrEnd{text-align: center;padding: 15vw 0;background: white;}
  svg{width: 22vw;height: 22vw;}
.ln1{ font-size: 7vw;font-weight: bold;padding-top: 8vw;}
.ln2{font-size: 5.6vw;padding: 2vw 0;}
.ln3{color:#869A95;font-size: 5vw}
@media screen and (min-width: 760px) {
  #scrEnd{padding: 8vw 0;}
  svg{width: 6vw;height: 6vw;}
  .ln1{font-size: 2vw;padding-top: 3vw;}
  .ln2{font-size: 1.6vw;padding: 1vw 0;}
  .ln3{font-size: 1.4vw;}
}
@media screen and (min-width: 1140px) {
  #scrEnd{padding: 40px 0;}
  svg{width: 68px;height: 68px;}
  .ln1{font-size: 22px;padding-top: 40px;}
  .ln2{font-size: 18px;padding: 15px 0;}
  .ln3{font-size: 16px;}
}
</style>
